/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid,
  Tooltip,
  Box,
  Snackbar,
} from '@mui/material'
import PropTypes from 'prop-types'
import { Alert } from '@material-ui/lab'

import esLocale from 'date-fns/locale/es'
import CurrencyFormat from 'react-currency-format'
import InfoIcon from '@material-ui/icons/Info'

import {
  Layout,
  Row,
  Col,
  Space,
  Tabs,
  Form,
  InputNumber,
  Collapse,
  Button,
  DatePicker,
  Checkbox,
  Typography,
  Alert as AntdAlert,
} from 'antd'

import dayjs from 'dayjs'

//HELPERS
import {
  formatDBDate,
  checkDateIsBetweenRange,
  addArrayItems,
  formatDateToDB,
  rangeBetweenDates,
} from '../../utils/helpers'

//API
import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import { firebaseDb } from '../../config/firebaseConfig'

import {
  getScheduleExperience,
} from '../../services/FirebaseServices/experienceServices'

import {
  getExperienceServicesByType,
  getAllServices,
  getResourcesByDayAndHour,
  checkAvailabilityHotels,
} from '../../services/FirebaseServices/reservationServices'

import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectTimeSelect,
  makeSelectPartialPrice,
  makeSelectAddonsPrice,
  makeSelectAddonsPersonsPrice,
  makeSelectReservationPrice,
  makeSelectSelectedAddons,
  makeSelectHotelHour,
  makeSelectSingleLimit,
  makeSelectGiftCard,
  set_start_date,
  set_end_date,
  set_guest_amount,
  set_child_amount,
  set_total_price,
  set_single_date,
  set_time,
  set_time_select,
  set_hotel_hour,
  set_partial_price,
  set_addons_price,
  set_addons_persons_price,
  set_reservation_price,
  set_selected_addons,
  set_service,
  set_single_limit,
  set_is_gift_card,
} from '../../redux/ducks/reservationDetails'
import updateLocale from 'dayjs/plugin/updateLocale'
import moment from 'moment'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectSingleExperience,
    makeSelectGuestAmount,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectSingleDate,
    makeSelectTime,
    makeSelectAgency,
    makeSelectTimeSelect,
    makeSelectPartialPrice,
    makeSelectAddonsPrice,
    makeSelectAddonsPersonsPrice,
    makeSelectReservationPrice,
    makeSelectSelectedAddons,
    makeSelectHotelHour,
    makeSelectSingleLimit,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  ) => ({
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  }),
)

const actionDispatch = (dispatch) => ({
  setStartDate: (startDate) => dispatch(set_start_date(startDate)),
  setEndDate: (endDate) => dispatch(set_end_date(endDate)),
  setGuestAmount: (guestAmount) => dispatch(set_guest_amount(guestAmount)),
  setChildAmount: (childAmount) => dispatch(set_child_amount(childAmount)),
  setTotalPrice: (totalPrice) => dispatch(set_total_price(totalPrice)),
  setSingleDate: (singleDate) => dispatch(set_single_date(singleDate)),
  setTime: (time) => dispatch(set_time(time)),
  setTimeSelect: (timeSelect) => dispatch(set_time_select(timeSelect)),
  setHotelHour: (hotelHour) => dispatch(set_hotel_hour(hotelHour)),
  setPartialPrice: (partialPrice) => dispatch(set_partial_price(partialPrice)),
  setAddonsPrice: (addonsPrice) => dispatch(set_addons_price(addonsPrice)),
  setAddonsPersonsPrice: (addonsPersonsPrice) =>
    dispatch(set_addons_persons_price(addonsPersonsPrice)),
  setReservationPrice: (reservationPrice) =>
    dispatch(set_reservation_price(reservationPrice)),
  setSelectedAddons: (selectedAddons) =>
    dispatch(set_selected_addons(selectedAddons)),
  setService: (service) => dispatch(set_service(service)),
  setSingleLimit: (singleLimit) => dispatch(set_single_limit(singleLimit)),
  setIsGiftCard: (giftCard) => dispatch(set_is_gift_card(giftCard)),
})

const _ = require('lodash')

const ReservationDetailsHotel = ({ handleNext, classes, hotDeal }) => {
  const {
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    singleDate,
    time,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    giftCard,
  } = useSelector(stateSelector)
  const {
    setStartDate,
    setEndDate,
    setGuestAmount,
    setTotalPrice,
    setChildAmount,
    setSingleDate,
    setTime,
    setHotelHour,
    setPartialPrice,
    setAddonsPrice,
    setAddonsPersonsPrice,
    setReservationPrice,
    setSelectedAddons,
    setIsGiftCard,
  } = actionDispatch(useDispatch())

  const [schedule, setSchedule] = useState({})
  const [isErrorStartDate, setIsErrorStartDate] = useState(false)
  const [isErrorEndDate, setIsErrorEndDate] = useState(false)
  const [isErrorGuestAmount, setIsErrorGuestAmount] = useState(false)
  const [isErrorChildAmount, setIsErrorChildAmount] = useState(false)
  const [snackOpen, setSnackOpen] = useState({ isOpen: false, message: '' })
  const [isExperiencesEnded, setIsExperienceEnded] = useState(false)
  const [isServiceBlocked, setIsServiceBlocked] = useState(false)
  const [isServicesBlocked, setIsServicesBlocked] = useState(false)
  const [timedBlockersAlert, setTimedBlocksAlert] = useState(true)
  const [isAvailableCapacity, setIsAvailableCapacity] = useState(false)
  const [isAvailableminimumDays, setIsAvailableMinimumDays] = useState(false)
  const [giftCardNights, setGiftCardNights] = useState(0)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [openSnackBarRange, setOpenSnackBarRange] = useState(false)
  const [value, setValue] = React.useState(0)
  const [openSnackBarCapacity, setOpenSnackBarCapacity] = useState(false)
  const [openSnackBarMinDays, setOpenSnackBarMinDays] = useState(false)
  const [scheduleDays, setScheduleDays] = useState('')
  const [reservations, setReservations] = useState()
  const [reservasPostToday, setReservasPostToday] = useState([])
  const [activeKey, setActiveKey] = useState('tab1')
  const [selectedDates, setSelectedDates] = useState([])
  const [initialized, setInitialized] = useState(false)
  const [guests, setGuests] = useState(0)
  const [guestsGift, setGuestsGift] = useState(0)
  const [services, setServices] = useState([])
  const [alertPerRange, setAlertPerRange] = useState(false)
  const localeMap = { es: esLocale }
  const [changeStartDate, setChangeStartDate] = useState(false)
  const [changeEndDate, setChangeEndDate] = useState(false)
  const [changeEndDateToAmounts, setChangeEndDateToAmounts] = useState(false)
  const [pricePerPersonOcupation, setPricePerPersonOcupation] = useState(0)
  const [resources, setResources] = useState([])
  const [availabilityInResourceDay, setAvailabilityInResourceDay] = useState([])
  const dateFormat = 'MM/DD/YYYY'

  dayjs.extend(updateLocale)
  dayjs.updateLocale('en', {
    weekStart: 1,
  })

  //Resources Hotel MEJORAR
  useEffect(() => {
    const data = { agencyId: agency.key, experienceId: singleExperience.key }
    // functon para traerme todos los usos de todos los recursos asociados a la experincia
    const getAvailabilityAndFilterHours = async (fetchedResources) => {
      const filteredResources = fetchedResources?.filter((resource) => {
        return resource?.idsExperiences?.includes(singleExperience.key) && resource.isActive
      })

      if (filteredResources.length > 0) {
        try {
          let lastAvailability = []
          for (const resource of filteredResources) {
            const availability = await checkAvailabilityHotels(agency.key, resource.id);  // esta mal le nombre, trae los aviability de los recursos (uso de recursos)
            availability.forEach((avail) => lastAvailability.push(avail))
          }
          return lastAvailability
        } catch (error) {
          console.error(error);
        }
      }
    }

    const fetchData = async () => {
      const fetchedResources = await getResourcesByDayAndHour(data);
      const availabilityByResource = await getAvailabilityAndFilterHours(fetchedResources)
      setResources(fetchedResources);
      setAvailabilityInResourceDay(availabilityByResource);
    };
    fetchData();
  }, [])

  //End Resources Hotel
  useEffect(() => {
    if (changeEndDateToAmounts === true) {
      handleGuestAmount(guestAmount, 'adult')
      setChangeEndDateToAmounts(false)
    }
  }, [changeEndDateToAmounts])

  useEffect(() => {
    if (changeStartDate || changeEndDate) {
      filterDatesInRange(startDate, endDate);
      setChangeStartDate(false);
      setChangeEndDate(false);
    }
  }, [changeStartDate, changeEndDate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = {
          agencyId: agency.key,
          experienceId: singleExperience.key,
        }
        const result = await getAllServices(data)
        setServices(result)
      } catch (error) {
        console.error('Error fetching services:', error)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (!hotDeal) {
      return null
    } else if (hotDeal && hotDeal?.giftCard?.isGiftCard) {
      setIsGiftCard(true)
      setValue(1)
    }
  }, [])

  useEffect(() => {
    if (hotDeal && singleExperience.partialPercentage === 0) {
      // setGuestAmount(hotDeal.persons)
      // handleGuestAmount(hotDeal.persons, 'adult')

      setStartDate(new Date(hotDeal.dayFrom))
      setEndDate(new Date(hotDeal.dayTo))
    }
  }, [])

  useEffect(() => {
    const daysOfWeek = []
    Object.entries(schedule).forEach(([key, value]) => {
      if (key === 'days') {
        daysOfWeek.push(value)
      }
    })
    setScheduleDays(daysOfWeek)
  }, [schedule])

  useEffect(() => {
    getScheduleExperience(agency.key, singleExperience.key)
      .then((res) => {
        setSchedule(res)
      })
      .catch((err) =>
        console.log(
          'Hubo un error al realizar su peticion. Por favor, intente mas tarde.',
        ),
      )
  }, [])

  useEffect(() => {
    var timeleft = 10
    var downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer)
        setTimedBlocksAlert(false)
      }
      timeleft -= 1
    }, 1000)

    validEndPeriodDate()

    if (
      !selectedAddons.length &&
      singleExperience.addons &&
      singleExperience.addons.length
    ) {
      const selected = singleExperience?.addons.map((item) => ({
        ...item,
        selected: false,
      }))
      setSelectedAddons(selected)
    }
    // const date = new Date()
    // setSingleDate(date)
  }, [])

  useEffect(() => {
    resetTotalPersons()
  }, [selectedAddons])

  //GET SERVICES BLOCKEDS
  useEffect(() => {
    getServicesBlockeds()
  }, [])

  const tabClick = (key) => {
    if (key === 'tab1') {
      setIsGiftCard(false)
      // handleGuestAmount(isNaN(parseInt(0, 10)) ? 0 : parseInt(0, 10), 'adult')

      setStartDate(null)
      setEndDate(null)
    } else {
      setIsGiftCard(true)
      isGiftCardStartDate()
      // setGuests(0)
      // handleGuestAmount(isNaN(parseInt(0, 10)) ? 0 : parseInt(0, 10), 'adult')

      isGiftCardEndDate()
      // const date = new Date()
      // const nextDay =
      //   singleExperience.minimumDays > 0
      //     ? new Date(date).getTime() + singleExperience.minimumDays * 86400000
      //     : new Date(date).getTime() + 86400000
      // setStartDate(new Date(date))
      // setEndDate(new Date(nextDay))
      // setSingleDate(date)
    }
  }

  const maxTo = singleExperience?.pricePerOcupation?.reduce((max, obj) => {
    const toNumber = parseInt(obj.to)
    return toNumber > max ? toNumber : max
  }, 0)

  const resetSelectedAddons = () => {
    if (singleExperience?.addons) {
      const selected = singleExperience?.addons.map((item) => ({
        ...item,
        selected: false,
      }))
      setSelectedAddons([])
      setSelectedAddons(selected)
    } else {
      setSelectedAddons([])
    }
  }
  const handlePrice = (amount, type) => {
    if (singleExperience.type === 'GROUP') {
      handleGroupPrice(amount, type)
    } else {
      handleSinglePrice(amount, type)
    }
  }

  const handlePanelChange = (value, mode) => {
    if (mode === 'date') {
      const currentMonth = dayjs(value)
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setStartDate()
      setEndDate()
      setSelectedDates(formattedDates)
    }
  }

  const handleOpenChange = async (open) => {
    if (open && !initialized) {
      // Ejecutar la lógica cuando el DatePicker se abre por primera vez
      const currentMonth = dayjs()
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setSelectedDates(formattedDates)

      setInitialized(true)
    }
  }

  const formatDate = (date) => {
    const isoDate = date.toISOString()
    const formattedDate = isoDate.split('T')[0]
    return formattedDate
  }

  const filterDates = (date) => {
    try {
      const dateFormatted = formatDate(date)
      const actualService = services.find((serv) => {
        return serv?.disponibility?.find((item) => item.day === dateFormatted)
      })

      //PARA DISP X SCHEDULECAPACITY
      const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
      const getDay = date.day()
      const selectedDate = new Date(date)
      let year = selectedDate.getFullYear()
      let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
      let day = selectedDate.getDate().toString().padStart(2, '0')
      let numberOfDay = selectedDate.getDay()
      const formatDateToSchedule = year + '-' + month + '-' + day
      const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

      function sortDays(a, b) {
        return days.indexOf(a.name) - days.indexOf(b.name)
      }
      const hoursSchedulePeriodicity = schedule.days
      hoursSchedulePeriodicity.sort(sortDays)
      const arrayScheduleHours = hoursSchedulePeriodicity[getDay].time

      if (arrayScheduleHours.length === 0) {
        return true
      }

      const periodicity = singleExperience.periodicity.indexOf(days[getDay])
      if (periodicity === -1) {
        return true
      }
      const totalPersons = guestAmount + childAmount
      if (
        singleExperience.type === 'PXQ' ||
        singleExperience.type === 'SINGLE' ||
        singleExperience.type === 'PXO'
      ) {
        if (totalPersons > selectedDay.disponibility) {
          return true
        }
      }

      const filteredResources = resources?.filter((resource) => {
        return resource?.idsExperiences?.includes(singleExperience.key) && resource.isActive;
      });

      const countOccurrencesInObjects = (date, objectsObject, resourceId) => {
        let count = 0
        for (const key in objectsObject) {
          const obj = objectsObject[key]
          if (obj?.daysRange?.[date] && obj.resourceId === resourceId) {
            count++
          }
        }
        return count
      }

      const getDatesWithTotalUsed = (objectsArray, resourceId, targetDate) => {
        let totalUsed = 0;

        for (const obj of objectsArray) {
          // Check if the object is for the correct resource
          if (obj.resourceId === resourceId) {
            // Check if the target date exists in the daysRange
            if (obj.daysRange.hasOwnProperty(targetDate)) {
              totalUsed += obj.used;
            }
          }
        }

        return totalUsed;
      };

      if (availabilityInResourceDay?.length > 0) {

        const singleResources = filteredResources.filter(resource => resource.isSingle);
        const nonSingleResources = filteredResources.filter(resource => !resource.isSingle);

        const isAnySingleResourceAvailable = [];
        const allNonSingleResourceAvailable = [];


        // Check availability for single resources
        for (const resource of singleResources) {
          if (resource.isPrivate) {
            const occurrences = countOccurrencesInObjects(formatDateToSchedule, availabilityInResourceDay, resource.id);
            if (resource.quantity > occurrences) {
              isAnySingleResourceAvailable.push(true);
              break;
            }
          } else if (!resource.isPrivate) {
            const totalUsed = getDatesWithTotalUsed(availabilityInResourceDay, resource.id, formatDateToSchedule);
            if (totalUsed + totalPersons <= resource.quota) {
              isAnySingleResourceAvailable.push(true);
              break;
            }
          }
        }

        // Check availability for non-single resources
        for (const resource of nonSingleResources) {
          if (resource.isPrivate) {
            // check aca
            const occurrences = countOccurrencesInObjects(formatDateToSchedule, availabilityInResourceDay, resource.id);
            if (resource.quantity > occurrences) {
              allNonSingleResourceAvailable.push(true);
            } else {
              allNonSingleResourceAvailable.push(false);
            }
          } else if (!resource.isPrivate) {
            // check aca
            const totalUsed = getDatesWithTotalUsed(availabilityInResourceDay, resource.id, formatDateToSchedule);

            if (totalUsed + totalPersons <= resource.quota) {
              allNonSingleResourceAvailable.push(true);
            } else {
              allNonSingleResourceAvailable.push(false);
            }
          }
        }

        // chekeo si los arreglos tienen informacion adentro
        // verifico que ALGUN RECURSO SINGLE cuente con disponibilidad
        // verifico que TODOS LOS RECURSOS NO SINGLE cuentan con disponibilidad
        const singleVerification = singleResources.length === 0 ? true : isAnySingleResourceAvailable.some((item) => item === true)
        const nonSingleVerification = nonSingleResources.length === 0 ? true : !allNonSingleResourceAvailable.some((item) => item === false)

        if (singleVerification && nonSingleVerification) {
          // return a disable date = flase porque hay disponibilidad
          return false
        } else {
          return true
        }

      } else if (!!actualService) {
        // si no hay recursos configurados chekeo servicios (deberia chekear reservas)
        const disponibilityForDate = actualService.disponibility.find(
          (item) => item.day === dateFormatted,
        )
        if (disponibilityForDate) {
          const actualSales = disponibilityForDate.sales
          const actualCapacity = disponibilityForDate.weeklyCapacity
          const totalCapacity = actualCapacity - actualSales
          if (
            singleExperience.type === 'SINGLE' ||
            singleExperience.type === 'PXQ' ||
            singleExperience.type === 'PXO'
          ) {
            if (totalPersons >= totalCapacity) {
              return true
            } else {
              return false
            }
          } else {
            if (actualSales >= actualCapacity) {
              return true
            } else {
              return false
            }
          }
        } else {
          return true
        }
      } else {
        return false
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleGuestAmount = async (value) => {
    await validateHotelServices()
    const available = await firebaseDb
      .collection(
        `agency/${agency.key}/experiences/${singleExperience.key}/schedule`,
      )
      .get()
    available.docs.forEach((r) => {
      const day =
        new Date(singleDate).getDay() > 0
          ? new Date(singleDate).getDay() - 1
          : 6
      const days = r.data().days

      const disponibility = giftCard ? 2 : days[day].disponibility
    })

    setIsErrorGuestAmount(false)
    const totalGuest = value + childAmount

    if (
      singleExperience.typePersons === 0 ||
      totalGuest <= singleExperience.typePersons
    ) {
      setGuestAmount(parseInt(value, 10))
      const type = 'adult'
      handlePrice(parseInt(value, 10), type)
    } else {
      setIsErrorGuestAmount(true)
    }
  }

  const handleChildAmount = async (value) => {
    await validateHotelServices()
    const available = await firebaseDb
      .collection(
        `agency/${agency.key}/experiences/${singleExperience.key}/schedule`,
      )
      .get()
    available.docs.forEach((r) => {
      const day =
        new Date(singleDate).getDay() > 0
          ? new Date(singleDate).getDay() - 1
          : 6
      const days = r.data().days

      const disponibility = giftCard ? 2 : days[day].disponibility
    })

    setIsErrorChildAmount(false)
    const totalGuest = value + guestAmount

    if (
      singleExperience.typePersons === 0 ||
      totalGuest <= singleExperience.typePersons
    ) {
      setChildAmount(parseInt(value, 10))
      const type = 'child'

      handlePrice(parseInt(value, 10), type)
    } else {
      setIsErrorChildAmount(true)
    }
  }

  const validGuestAmount = () => {
    if (guestAmount === 0) {
      setIsErrorGuestAmount(true)
      return false
    }

    // if (giftCard && guestAmount > 2) {
    //   setIsErrorGuestAmount(true)
    //   return false
    // }

    setIsErrorGuestAmount(false)
    return true
  }

  const validStartDate = () => {
    if (startDate === null) {
      setIsErrorStartDate(true)
      return false
    } else {
      setIsErrorStartDate(false)
      return true
    }
  }

  const validEndDate = () => {
    if (endDate === null) {
      setIsErrorEndDate(true)
      return false
    }

    if (
      (startDate - endDate) / -86400000 < singleExperience.minimumDays &&
      !giftCard
    ) {
      setIsAvailableMinimumDays(true)
      setOpenSnackBarMinDays(true)
    } else {
      setIsErrorEndDate(false)
      return true
    }
  }

  const validEndPeriodDate = () => {
    const { dateEnd } = singleExperience

    if (dateEnd) {
      const finalDate = new Date(dateEnd)
      const currentDate = new Date()

      if (currentDate > finalDate) {
        setIsExperienceEnded(true)
        setOpenSnackBar(true)
      } else {
        setIsExperienceEnded(false)
      }
    } else {
      setIsExperienceEnded(false)
    }
  }

  const validateReservationPrice = () => {
    if (reservationPrice < 1000) {
      return false
    }

    return true
  }

  const filterDatesInRange = (startDate, endDate) => {
    if (giftCard) {
      return true
    }

    const currentDate = new moment(startDate)
    const end = new moment(endDate)
    while (currentDate < end) {
      const disabledDate = filterDates(currentDate)
      if (disabledDate === true) {
        setAlertPerRange(true)
        setOpenSnackBarRange(true)
        return false // Si alguna fecha no está disponible, devuelve false
      }
      setAlertPerRange(false)
      setOpenSnackBarRange(false)
      currentDate.add(1, 'day')
    }

    return true // Si todas las fechas están disponibles, devuelve true
  }

  const validateForm = async () => {
    if (giftCard) {
      const date = new Date()
      const next = new Date(date).getTime() + giftCardNights * 86400000
      setStartDate(date)
      setEndDate(new Date(next))
    }

    const boolGuestAmount = validGuestAmount()
    const boolStartDate = validStartDate()
    const boolEndDate = validEndDate()
    const boolService = await validateHotelServices()
    const boolReservationPrice = validateReservationPrice()

    if (!boolReservationPrice) {
      setSnackOpen({
        ...snackOpen,
        isOpen: true,
        message: 'El total no puede ser menos a $1000',
      })
      return
    }

    if (giftCard) {
      if (singleExperience.partialPercentage > 0) {
        setPartialPrice(
          ((!!reservationPrice
            ? reservationPrice + addonsPrice + addonsPersonsPrice
            : 0) *
            singleExperience.partialPercentage) /
          100,
        )
        handleNext()
      } else {
        handleNext()
      }
    } else if (boolStartDate && boolEndDate && boolGuestAmount) {
      if (boolService) {
        if (singleExperience.partialPercentage > 0) {
          setPartialPrice(
            ((!!reservationPrice
              ? reservationPrice + addonsPrice + addonsPersonsPrice
              : 0) *
              singleExperience.partialPercentage) /
            100,
          )
          handleNext()
        } else {
          handleNext()
        }
      }
    } else {
      null
    }
  }

  const handleNights = () => {
    const date1 = new Date(startDate)
    const date2 = new Date(endDate)

    const differenceInTime = date2.getTime() - date1.getTime()

    let differenceInDays = differenceInTime / (1000 * 3600 * 24)

    if (giftCard) {
      return giftCardNights === 0 ? 0 : giftCardNights
    }

    return differenceInDays ? Math.ceil(differenceInDays) : 0
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      validateForm()
    }
  }

  const validateHotelServices = async () => {
    if (!startDate && !endDate) {
      return false
    }

    if (giftCard) {
      return true
    }

    const datesArray = rangeBetweenDates(startDate, endDate)

    const servicesResponse = await getExperienceServicesByType(
      agency.key,
      singleExperience.key,
      'HOTEL',
    )

    const filterServices = servicesResponse.filter(
      (item) => {
        if (item.isBlocked) {
          return true
        } else {
          return false
        }
      }
    )

    const checkBlockedServices = (services, datesArray) => {
      // Normalize date function
      const normalizeDate = (date) => {
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      };

      console.log(datesArray)
      // Iterate through datesArray and check for blocked services
      for (let i = 0; i < datesArray.length - 1; i++) {
        const normalizedDate = normalizeDate(datesArray[i]);
        const nextNormalizedDate = normalizeDate(datesArray[i + 1]);

        // Check if any service blocks the date range from normalizedDate to nextNormalizedDate
        const isBlocked = services.some(service => {
          const startDate = normalizeDate(service.dateInit);
          const endDate = normalizeDate(service.dateEnd);

          return startDate <= normalizedDate && nextNormalizedDate <= endDate && service.isBlocked;
        });

        if (isBlocked) {
          return true; // Return true if any blocked service is found
        }
      }

      return false; // Return false if no blocked services are found
    };

    const isBlocked = checkBlockedServices(filterServices, datesArray);

    if (isBlocked) {
      setIsServiceBlocked(true)
      setTime('')
      return false
    } else {
      setIsServiceBlocked(false)
      return true
    }
  }

  const handleMinDate = () => {
    const { dateInit } = singleExperience

    if (dateInit) {
      const init = new Date(dateInit.split('-'))
      const currentDate = new Date()
      const current = new Date(currentDate.setDate(currentDate.getDate() - 1))
      if (current > init) {
        return current
      } else {
        return init
      }
    } else {
      return new Date()
    }
  }

  const handleMaxDate = () => {
    const { dateEnd } = singleExperience

    if (dateEnd) {
      return new Date(dateEnd)
    }
  }

  const guestIsDisable = () => {
    if (singleExperience.category === 'HOTEL') {
      if (isExperiencesEnded) {
        return true
      } else {
        return false
      }
    }
  }

  const totalizerAddons = () => {
    let sum = 0
    const addons = selectedAddons.filter(
      (fil) => fil.isSpecial && fil.selected && fil.quantity > 0,
    )
    if (addons.length > 0) {
      addons.map((addon, index) => {
        sum = sum + addon.price * addon.quantity
      })
      setAddonsPersonsPrice(sum)
      // setTotalAddonsPersons(sum)
    } else {
      setAddonsPersonsPrice(0)
    }
  }

  const resetTotalPersons = () => {
    const total = 0
    setTimeout(() => {
      setAddonsPersonsPrice(total)
      totalizerAddons()
    }, 500)
  }

  const handleChangeQty = (quantity, addon, index) => {
    selectedAddons[index].quantity = quantity
    setSelectedAddons(selectedAddons)
    totalizerAddons()
  }

  const handleAddonsSpecial = (event, addon, index) => {
    const copyAddons = [...selectedAddons]
    copyAddons[index] = { ...copyAddons[index], selected: event }
    setSelectedAddons(copyAddons)
    totalizerAddons()
  }

  const handleAddons = (event, addon, index) => {
    if (event) {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: true }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //Se agrega el precio del addon
      const addPrice = addonsPrice + totalGuest * addon.price
      setAddonsPrice(addPrice)
      setTotalPrice(addPrice + reservationPrice)
      setPartialPrice(
        (addPrice + reservationPrice) *
        (singleExperience.partialPercentage / 100),
      )
    } else {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: false }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //se resta el precio del addon
      const minusPrice = addonsPrice - totalGuest * addon.price
      setAddonsPrice(minusPrice)
      setTotalPrice(reservationPrice + minusPrice)
      setPartialPrice(
        (reservationPrice + minusPrice) *
        (singleExperience.partialPercentage / 100),
      )
    }
  }

  const handleDateAndTime = (arraySchedule, date) => {
    if (singleExperience.category === 'HOTEL') {
      const day = date.day()
      const filterDay = arraySchedule.days.filter((item) => item.day === day)

      setHotelHour(filterDay[0].time[0])
      // setIsDisableTime(false)
    }
  }

  const handleSinglePrice = (amount, type) => {
    if (singleExperience.seasons && singleExperience.seasons.length) {
      const checkIfDateIsSeason = singleExperience.seasons.filter((item) => {
        return checkDateIsBetweenRange(
          formatDateToDB(singleDate),
          item.startDate,
          item.endDate,
        )
      })

      if (checkIfDateIsSeason.length) {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice =
            amount * checkIfDateIsSeason[0].valuePerNight * handleNights()

          childPrice =
            childAmount * checkIfDateIsSeason[0].childPrice * handleNights()

          childPrice = !!childPrice ? childPrice : 0
          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
              (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice =
            guestAmount * checkIfDateIsSeason[0].valuePerNight * handleNights()

          childPrice = amount * singleExperience.valuePerChild * handleNights()
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      } else {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = amount * singleExperience.valuePerPerson * handleNights()
          childPrice =
            childAmount * singleExperience.valuePerChild * handleNights()
          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
              (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          childPrice = amount * singleExperience.valuePerChild * handleNights()
          adultPrice =
            guestAmount * singleExperience.valuePerPerson * handleNights()
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      }
    } else {
      let adultPrice = 0,
        childPrice = 0,
        addonTotalPrice = 0
      if (type === 'adult') {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        if (singleExperience.type === 'PXQ') {
          const pricesQuantity = singleExperience.priceQuantity
          const index = pricesQuantity.findIndex(
            (x) => x.from <= amount && x.to >= amount,
          )

          adultPrice =
            amount *
            pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1]
              .price
        } else if (
          singleExperience?.pricePerOcupation?.length > 0 &&
          singleExperience.type === 'PXO'
        ) {
          const pricesOcup = singleExperience.pricePerOcupation
          const index = pricesOcup.findIndex(
            (x) => x.from <= amount && x.to >= amount,
          )

          adultPrice =
            pricesOcup[index !== -1 ? index : pricesOcup.length - 1].price *
            handleNights()
          setPricePerPersonOcupation(
            pricesOcup[index !== -1 ? index : pricesOcup.length - 1].price,
          )
        } else {
          adultPrice = amount * singleExperience.valuePerPerson * handleNights()
        }

        childPrice =
          childAmount * singleExperience.valuePerChild * handleNights()

        setReservationPrice(adultPrice + childPrice)

        setTotalPrice(adultPrice + childPrice + addonTotalPrice)

        if (singleExperience.isPartialCharge) {
          setPartialPrice(
            (adultPrice + childPrice + addonTotalPrice) *
            (singleExperience.partialPercentage / 100),
          )
        }
      } else {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        childPrice = amount * singleExperience.valuePerChild * handleNights()
        adultPrice =
          guestAmount * singleExperience.valuePerPerson * handleNights()
        setReservationPrice(childPrice + adultPrice)
        setTotalPrice(adultPrice + childPrice + addonTotalPrice)
      }
    }
  }

  const getServicesBlockeds = async () => {
    const response = await firebaseDb
      .collection(
        `agency/${agency.key}/experiences/${singleExperience.key}/services`,
      )
      .where('isBlocked', '==', true)
      .get()

    const services = []
    response.forEach((r) => {
      services.push({ id: r.id, ...r.data() })
    })
    //setServicesBlockeds(services)
    setIsServicesBlocked(services.length > 0)
  }

  const handleGroupPrice = (amount, type) => {
    if (!amount) {
      setReservationPrice(0)
      setTotalPrice(0)
      setAddonsPersonsPrice(0)
      setPartialPrice(0)
    } else {
      if (singleExperience.category === 'HOTEL') {
        let reservationPrice = 0,
          addonTotalPrice = 0
        if (singleExperience.seasons && singleExperience.seasons.length) {
          const selectedDatesArray = rangeBetweenDates(startDate, endDate)

          const checkPrices = selectedDatesArray.map((date) => {
            const season = singleExperience.seasons.filter((season) =>
              checkDateIsBetweenRange(date, season.startDate, season.endDate),
            )

            if (season.length) {
              return season[0].valuePerNight
            } else {
              return singleExperience.valuePerPerson
            }
          })

          checkPrices.pop()

          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          const addPrices = addArrayItems(checkPrices)
          reservationPrice = addPrices
          setReservationPrice(reservationPrice)
          setTotalPrice(addonTotalPrice + reservationPrice)
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          reservationPrice = singleExperience.valuePerPerson * handleNights()
          setReservationPrice(reservationPrice)
          setTotalPrice(reservationPrice + addonTotalPrice)
        }

        if (singleExperience.isPartialCharge) {
          const calcPartialPrice =
            (reservationPrice + addonTotalPrice) *
            (singleExperience.partialPercentage / 100)

          const rounded = calcPartialPrice.toFixed(2)
          setPartialPrice(rounded)
        }
      }
    }
  }

  function isGiftCardStartDate() {
    const date = new Date()
    const day = dayjs(date)
    setIsErrorStartDate(false)
    setIsErrorEndDate(false)
    setReservationPrice(0)
    // handleGuestAmount(0, 'adult')
    setTotalPrice(0)
    setAddonsPersonsPrice(0)
    resetSelectedAddons()
    handleDateAndTime(schedule, day)
    const nextDay = new Date(date).getTime() + 86400000
    setStartDate(new Date(date))
    setEndDate(new Date(nextDay))
  }

  function isGiftCardEndDate() {
    const date = new Date()
    setIsErrorEndDate(false)
    setEndDate(new Date(date))
    setReservationPrice(0)
    // handleGuestAmount(0, 'adult')
    setTotalPrice(0)
    resetSelectedAddons()
    setAddonsPersonsPrice(0)
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  }

  const handleChange = (newValue, key) => {
    setGuestAmount(0)
    setChildAmount(0)
    setActiveKey(key)
    setValue(newValue)
  }


  const allPxoData = [
    {
      key: 'pxqTab',
      label: 'Tabla de precios por cantidad de ocupación',
      children:
        singleExperience && singleExperience?.pricePerOcupation
          ? singleExperience.pricePerOcupation
            .slice() // Hacemos una copia del array para no modificar el original
            .sort((a, b) => a.from - b.from) // Ordenamos de menor a mayor por pxq.from
            .map((pxo, i) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '-3%',
                  }}
                  key={i}
                >
                  <p>
                    De {pxo.from} a {pxo.to} persona(s)
                  </p>
                  <CurrencyFormat
                    value={pxo.price}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </div>
              )
            })
          : null,
    },
  ]

  const allPxqData = [
    {
      key: 'pxqTab',
      label: 'Tabla de precios por cantidad de personas',
      children:
        singleExperience && singleExperience.priceQuantity
          ? singleExperience.priceQuantity.map((pxq, i) => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '-3%',
                }}
              >
                <p key={i}>
                  De {pxq.from} a {pxq.to}
                </p>
                <CurrencyFormat
                  value={pxq.price}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </div>
            )
          })
          : null,
    },
  ]

  const items = [
    {
      key: 'tab1',
      label: 'RESERVA',
      children: (
        <div
          className="container-checkout"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            marginTop: '12px',
          }}
        >
          {isExperiencesEnded && (
            <Snackbar
              open={openSnackBar}
              autoHideDuration={6000}
              onClose={() => setOpenSnackBar(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                Esta experiencia ha culminado
              </Alert>
            </Snackbar>
          )}
          {alertPerRange && (
            <Snackbar
              open={openSnackBarRange}
              autoHideDuration={6000}
              onClose={() => setOpenSnackBarRange(false)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
              <Alert
                onClose={() => setOpenSnackBarRange(false)}
                severity="warning"
              >
                El servicio no contiene disponibilidad intermedia entre los días
                seleccionados
              </Alert>
            </Snackbar>
          )}
          <Row
            gutter={16}
            className="grid-reserva-step1"
            style={{ width: '100% !important' }}
          >
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="datepicker-step1"
            >
              <Form.Item
                label={(() => {
                  if (!singleExperience.minPassengers) {
                    return 'Participantes'
                  } else if (singleExperience.minPassengers > 0) {
                    return `Participantes (${singleExperience.minPassengers} o más)`
                  }
                })()}
                colon={false}
                className="itemColon"
                labelCol={{ span: 24 }}
              >
                <InputNumber
                  defaultValue={0}
                  min={
                    singleExperience.minPassengers >= 1
                      ? singleExperience.minPassengers
                      : 0
                  }
                  max={
                    singleExperience.type === 'PXO'
                      ? maxTo
                      : singleExperience.typePersons > 0
                        ? singleExperience.typePersons
                        : null
                  }
                  disabled={guestIsDisable()}
                  size="middle"
                  onKeyUp={handleKeyPress}
                  status={isErrorGuestAmount ? 'error' : null}
                  required
                  value={guestAmount}
                  onChange={(value) => {
                    if (value === null || value === undefined || value === '') {
                      value = 0
                    }
                    if (guestAmount >= 1) {
                      handleGuestAmount(value)
                    } else {
                      setGuestAmount(parseInt(value, 10))
                    }
                  }}
                  // onKeyDown={handleKeyDown}
                  className="inputnumber"
                />
              </Form.Item>
            </Col>
            {singleExperience.valuePerChild ? (
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="label-pChild-step1"
              >
                <Form.Item
                  label={(() => {
                    if (!singleExperience.kidsAge) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge === 0) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge > 0) {
                      return `Niños (hasta ${singleExperience.kidsAge} años)`
                    }
                  })()}
                  colon={false}
                  className="itemColon"
                  labelCol={{ span: 24 }}
                >
                  <InputNumber
                    defaultValue={0}
                    min={0}
                    size="middle"
                    disabled={guestIsDisable()}
                    status={isErrorChildAmount ? 'error' : null}
                    value={childAmount}
                    onChange={(value) => {
                      if (
                        value === null ||
                        value === undefined ||
                        value === ''
                      ) {
                        value = 0
                      }
                      if (childAmount >= 1) {
                        handleChildAmount(value)
                      } else {
                        setChildAmount(parseInt(value, 10))
                      }
                    }}
                    className="inputnumber"
                  // onKeyDown={handleKeyDown}
                  />
                </Form.Item>
              </Col>
            ) : null}
          </Row>
          <Row
            gutter={16}
            className="grid-reserva-step1"
            style={{ width: '100% important' }}
          >
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="datepicker-step1"
            >
              <Form.Item
                label="Llegada"
                labelCol={{ span: 24 }}
                colon={false}
                className="itemColon"
              >
                <DatePicker
                  className="inputnumber"
                  format={dateFormat}
                  disabled={
                    isExperiencesEnded || guestAmount === 0 ? true : false
                  }
                  status={isErrorStartDate ? 'error' : null}
                  onChange={(date) => {
                    setIsErrorStartDate(false)
                    setIsErrorEndDate(false)
                    setStartDate(new Date(date))
                    setChangeEndDateToAmounts(true)
                    setChangeStartDate(true)
                    handleDateAndTime(schedule, date)
                    const nextDay =
                      singleExperience.minimumDays > 0
                        ? new Date(date).getTime() +
                        singleExperience.minimumDays * 86400000
                        : new Date(date).getTime() + 86400000
                    setEndDate(new Date(nextDay))
                    console.log('change')
                  }}
                  onKeyUp={handleKeyPress}
                  onPanelChange={handlePanelChange}
                  value={startDate ? dayjs(startDate) : null}
                  allowClear={{ clearIcon: null }}
                  onOpenChange={handleOpenChange}
                  disabledDate={(date) => {
                    const minDate = handleMinDate()
                    const maxDate = handleMaxDate()
                    const currentDate = dayjs()
                    const minAllowedDate = currentDate.add(
                      singleExperience.previousDays,
                      'day',
                    )

                    if (minDate && date < minDate) {
                      return true
                    }

                    if (maxDate && date > maxDate) {
                      return true
                    }

                    // Deshabilita las fechas que son menores que la fecha mínima permitida
                    if (date < minAllowedDate) {
                      return true
                    }

                    const res = filterDates(date)
                    return res
                  }}
                />
              </Form.Item>
            </Col>

            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="label-pChild-step1"
            >
              <Form.Item
                label="Salida"
                labelCol={{ span: 24 }}
                colon={false}
                className="itemColon"
              >
                <DatePicker
                  className="inputnumber"
                  defaultValue={
                    startDate > endDate ? dayjs(startDate) : dayjs(endDate)
                  }
                  format={dateFormat}
                  disabled={
                    isExperiencesEnded || guestAmount === 0 ? true : false
                  }
                  status={isErrorEndDate ? 'error' : null}
                  onChange={(date) => {
                    setIsErrorEndDate(false)
                    setEndDate(new Date(date))
                    setChangeEndDateToAmounts(true)
                    setChangeEndDate(true)
                  }}
                  onKeyUp={handleKeyPress}
                  value={
                    startDate && startDate > endDate
                      ? dayjs(startDate)
                      : endDate
                        ? dayjs(endDate)
                        : null
                  }
                  allowClear={{ clearIcon: null }}
                  disabledDate={(date) => {
                    const minDate = handleMinDate()
                    const maxDate = handleMaxDate()

                    if (minDate && date < minDate) {
                      return true
                    }

                    if (maxDate && date > maxDate) {
                      return true
                    }

                    return filterDates(date)
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          {isServiceBlocked && (
            <Grid item xs={12}>
              <Alert severity="error">
                El servicio se encuentra bloqueado para el día de llegada
              </Alert>
            </Grid>
          )}

          {singleExperience.seasons &&
            singleExperience.seasons.map((item) => (
              <>
                <Row
                  gutter={16}
                  style={{ width: '100%', marginTop: '2%' }}
                  key={item.name}
                >
                  <Col xs={24}>
                    <AntdAlert
                      message={
                        <>
                          <Row gutter={16}>
                            <Col xs={12}>
                              <p style={{ margin: 0 }}>
                                Temporada: {item.name}
                              </p>
                              <p style={{ margin: 0 }}>
                                Precio:
                                <CurrencyFormat
                                  value={item.valuePerNight}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              </p>
                            </Col>
                            <Col xs={12}>
                              <p style={{ margin: 0 }}>
                                Comienzo:
                                {formatDBDate(item.startDate)}
                              </p>
                              <p style={{ margin: 0 }}>
                                Final:
                                {formatDBDate(item.endDate)}
                              </p>
                            </Col>
                          </Row>
                        </>
                      }
                      type="info"
                      showIcon
                    />
                  </Col>
                </Row>
              </>
            ))}

          {isAvailableCapacity && (
            <Snackbar
              open={openSnackBarCapacity}
              autoHideDuration={6000}
              onClose={() => setOpenSnackBarCapacity(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert
                onClose={() => setOpenSnackBarCapacity(false)}
                severity="error"
              >
                El rango de fechas seleccionadas contiene días sin
                disponibilidad
              </Alert>
            </Snackbar>
          )}

          {isAvailableminimumDays && (
            <Snackbar
              open={openSnackBarMinDays}
              autoHideDuration={6000}
              onClose={() => setOpenSnackBarMinDays(false)}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert
                onClose={() => setOpenSnackBarMinDays(false)}
                severity="error"
              >
                Cantidad mínima de noches es {`${singleExperience.minimumDays}`}
              </Alert>
            </Snackbar>
          )}

          {singleExperience.isPartialCharge &&
            singleExperience.partialPercentage !== 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Tipo de pago parcial (Inicial{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {singleExperience.partialPercentage}% -{' '}
                  {100 - singleExperience.partialPercentage}%
                </span>{' '}
                Restante )
              </Alert>
            </Grid>
          ) : hotDeal &&
            singleExperience.isPartialCharge &&
            singleExperience.partialPercentage ===
            0 ? null : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Con esta pre reserva se espera una confirmación del proveedor
                para realizar el pago
              </Alert>
            </Grid>
          ) : null}

          {singleExperience.type === 'PXQ' &&
            !!singleExperience.priceQuantity && (
              <Row gutter={16} style={{ width: '100%' }}>
                <Col span={24}>
                  <Collapse
                    size="small"
                    items={allPxqData}
                    expandIconPosition="end"
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            )}
          {singleExperience.type === 'PXO' &&
            !!singleExperience?.pricePerOcupation && (
              <Row
                gutter={16}
                style={{ width: '90%', margin: 'auto', marginTop: '2%' }}
              >
                <Col span={24}>
                  <Collapse
                    size="small"
                    items={allPxoData}
                    expandIconPosition="end"
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            )}
          <Row gutter={16} style={{ width: '100%' }}>
            {selectedAddons && selectedAddons.length > 0 ? (
              <Col span={24} style={{ width: '100%' }}>
                <p
                  style={{ margin: 0, fontWeight: 'bold' }}
                  className={classes.fontQuicksand}
                >
                  Servicios Adicionales
                </p>
                {selectedAddons.map((addon, index) => (
                  <Row
                    gutter={16}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      margin: '0',
                    }}
                    key={addon.key}
                    className={classes.fontMuli}
                  >
                    <Col
                      style={{
                        display: 'flex',
                        margin: '0',
                        justifyContent: 'start',
                        alignItems: 'center',
                        width: '60%',
                      }}
                    >
                      <Checkbox
                        checked={addon.selected}
                        onChange={(e) =>
                          addon.isSpecial
                            ? handleAddonsSpecial(
                              e.target.checked,
                              addon,
                              index,
                            )
                            : handleAddons(e.target.checked, addon, index)
                        }
                      />
                      <small
                        style={{
                          textTransform: 'capitalize',
                          marginLeft: '1%',
                        }}
                      >
                        {addon.name}
                      </small>
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        margin: '0',
                        justifyContent: 'end',
                        alignItems: 'center',
                        width: '40%',
                      }}
                    >
                      {addon.isSpecial && (
                        <div
                          style={{
                            width: '100%',

                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Col style={{ justifyContent: 'end' }}>
                            <InputNumber
                              disabled={!addon.selected}
                              defaultValue={1}
                              style={{
                                marginRight: '10px',
                                width: '50px',
                                height: '30px',
                                justifyContent: 'center',
                              }}
                              // value={!!addon.quantity ? addon.quantity : 0}
                              min={1}
                              onChange={(value) =>
                                handleChangeQty(parseInt(value), addon, index)
                              }
                            />
                          </Col>
                          <Col
                            style={{
                              justifyContent: 'end',
                            }}
                          >
                            <small>
                              <CurrencyFormat
                                value={addon.price}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                              />
                              {addon.isSpecial && '/un'}
                            </small>
                          </Col>
                        </div>
                      )}

                      {!addon.isSpecial && (
                        <>
                          <Col
                            style={{
                              justifyContent: 'end',
                            }}
                          >
                            <small>
                              <CurrencyFormat
                                value={addon.price}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                              />
                            </small>
                          </Col>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}
              </Col>
            ) : null}

            <Row gutter={16} style={{ width: '100%' }}>
              <hr className="hr-style" />

              <Col
                style={{
                  display: 'flex',
                  margin: 'auto',
                  paddingTop: '2%',
                  justifyContent: 'space-between',
                  width: '100%',
                  marginLeft: '2%',
                }}
                className={classes.fontQuicksand}
              >
                {singleExperience.type === 'GROUP'
                  ? 'Precio de la reserva'
                  : singleExperience.type === 'PXO'
                    ? 'Precio por noche'
                    : 'Precio por persona'}
                <CurrencyFormat
                  value={
                    singleExperience.type === 'PXO'
                      ? pricePerPersonOcupation
                      : singleExperience.valuePerPerson
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </Col>

              {singleExperience.valuePerChild ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Precio por niños{' '}
                  <CurrencyFormat
                    value={singleExperience.valuePerChild}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales{' '}
                  <CurrencyFormat
                    value={addonsPrice ? addonsPrice : 0}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales por persona{' '}
                  <CurrencyFormat
                    value={addonsPersonsPrice}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              <hr className="hr-style" />
              {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? null : (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Reserva{' '}
                  <CurrencyFormat
                    value={
                      !!reservationPrice
                        ? reservationPrice + addonsPrice + addonsPersonsPrice
                        : 0
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              )}
            </Row>

            {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              hotDeal ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará el pago de su pre-reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignContent: 'center',
                }}
              >
                <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span
                  style={{ marginRight: '5px', marginLeft: '5px' }}
                >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                <CurrencyFormat
                  value={
                    ((!!reservationPrice
                      ? reservationPrice + addonsPrice + addonsPersonsPrice
                      : 0) *
                      singleExperience.partialPercentage) /
                    100
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </p>
            ) : null}
          </Row>

          <Space
            style={{ width: '100%', marginTop: '2%', justifyContent: 'center' }}
          >
            <Button
              disabled={isExperiencesEnded || alertPerRange}
              variant="contained"
              onClick={validateForm}
              className="btn"
            >
              Continuar
            </Button>
          </Space>
        </div>
      ),
    },
    (singleExperience.isPartialCharge &&
      singleExperience.partialPercentage === 0) ||
      singleExperience.giftCardIsActive === false
      ? null
      : {
        key: 'tab2',
        label: 'GIFT CARD',
        children: (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              boxSizing: 'border-box',
            }}
            className="spacer"
          >
            {isExperiencesEnded && (
              <Snackbar
                open={openSnackBar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackBar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                  Esta experiencia ha culminado
                </Alert>
              </Snackbar>
            )}

            {singleExperience.seasons &&
              singleExperience.seasons.map((item) => (
                <>
                  <Row
                    gutter={16}
                    style={{ width: '100%', marginTop: '2%' }}
                    key={item.name}
                  >
                    <Col xs={24}>
                      <AntdAlert
                        message={
                          <>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <p style={{ margin: 0 }}>
                                  Temporada: {item.name}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Precio:
                                  <CurrencyFormat
                                    value={item.valuePerNight}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                  />
                                </p>
                              </Col>
                              <Col xs={12}>
                                <p style={{ margin: 0 }}>
                                  Comienzo:
                                  {formatDBDate(item.startDate)}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Final:
                                  {formatDBDate(item.endDate)}
                                </p>
                              </Col>
                            </Row>
                          </>
                        }
                        type="info"
                        showIcon
                      />
                    </Col>
                  </Row>
                </>
              ))}

            <Row
              gutter={16}
              className="grid-gift-step"
              style={{ width: '100% important!' }}
            >
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="participantesGift"
              >
                <Form.Item
                  label={`Noches a Reservar (min ${singleExperience.minimumDays})`}
                  labelCol={{ span: 24 }}
                  colon={false}
                  className="itemColon"
                >
                  <InputNumber
                    style={{
                      margin: 'auto',
                      width: '100% !important',
                    }}
                    defaultValue={singleExperience.minimumDays}
                    min={singleExperience.minimumDays}
                    onKeyUp={handleKeyPress}
                    status={isAvailableminimumDays ? 'error' : null}
                    required
                    value={giftCardNights}
                    onChange={(value) => {
                      if (
                        value === null ||
                        value === undefined ||
                        value === ''
                      ) {
                        value = 0
                      }
                      setGiftCardNights(value)
                      setIsAvailableMinimumDays(false)
                      resetSelectedAddons()
                      // setGuests(0)
                      setReservationPrice(0)
                      // setReservationPrice(0)
                      if (value < singleExperience.minimumDays) {
                        setIsAvailableMinimumDays(true)
                      } else {
                      }
                    }}
                    className="inputnumber"
                  // onKeyDown={handleKeyDown}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="datepicker-step1"
              >
                <Form.Item
                  label="Obsequiados(límite 2)"
                  labelCol={{ span: 24 }}
                  className="itemColon"
                  colon={false}
                >
                  <InputNumber
                    defaultValue={0}
                    disabled={guestIsDisable()}
                    min={0}
                    max={2}
                    style={{
                      margin: 'auto',
                      width: '100% !important',
                    }}
                    onKeyUp={handleKeyPress}
                    status={isErrorGuestAmount ? 'error' : null}
                    required
                    value={guestAmount}
                    onChange={(value) => {
                      handleGuestAmount(value, 'adult')
                      // handleGuestAmount(
                      //   isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10),
                      //   'adult',
                      // )
                      // handleGuestAmount(value, 'adult')
                    }}
                    // onOk={handleGuestAmount(guestsGift, 'adult')}

                    // onKeyDown={handleKeyDown}
                    className="inputnumber"
                  />
                </Form.Item>
              </Col>
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="label-pChild-step1"
              >
                <Form.Item
                  label={(() => {
                    if (!singleExperience.kidsAge) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge === 0) {
                      return 'Niños (hasta 12 años)'
                    } else if (singleExperience.kidsAge > 0) {
                      return `Niños (hasta ${singleExperience.kidsAge} años)`
                    }
                  })()}
                  colon={false}
                  className="itemColon"
                  labelCol={{ span: 24 }}
                >
                  <InputNumber
                    defaultValue={0}
                    min={0}
                    size="middle"
                    disabled={guestIsDisable()}
                    status={isErrorChildAmount ? 'error' : null}
                    value={childAmount}
                    onChange={(value) => {
                      if (
                        value === null ||
                        value === undefined ||
                        value === ''
                      ) {
                        value = 0
                      }
                      if (childAmount >= 1) {
                        handleChildAmount(value)
                      } else {
                        setChildAmount(parseInt(value, 10))
                      }
                    }}
                    className="inputnumber"
                  // onKeyDown={handleKeyDown}
                  />
                </Form.Item>
              </Col>
            </Row>

            {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
              <Grid item xs={12}>
                <Alert severity="warning" icon={false}>
                  Tipo de pago parcial (Inicial{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {singleExperience.partialPercentage}% -{' '}
                    {100 - singleExperience.partialPercentage}%
                  </span>{' '}
                  Restante )
                </Alert>
              </Grid>
            ) : hotDeal &&
              singleExperience.isPartialCharge &&
              singleExperience.partialPercentage ===
              0 ? null : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? (
              <Grid item xs={12}>
                <Alert severity="warning" icon={false}>
                  Con esta pre reserva se espera una confirmación del
                  proveedor para realizar el pago
                </Alert>
              </Grid>
            ) : null}

            {singleExperience.type === 'PXQ' &&
              !!singleExperience.priceQuantity && (
                <Row gutter={16} style={{ width: '100%' }}>
                  <Col span={24}>
                    <Collapse
                      size="small"
                      items={allPxqData}
                      expandIconPosition="end"
                      style={{ width: '100%' }}
                    />
                  </Col>
                </Row>
              )}
            {singleExperience.type === 'PXO' &&
              !!singleExperience?.pricePerOcupation && (
                <Row
                  gutter={16}
                  style={{ width: '90%', margin: 'auto', marginTop: '2%' }}
                >
                  <Col span={24}>
                    <Collapse
                      size="small"
                      items={allPxoData}
                      expandIconPosition="end"
                      style={{ width: '100%' }}
                    />
                  </Col>
                </Row>
              )}

            <Row gutter={16} style={{ width: '100%' }}>
              {selectedAddons && selectedAddons.length > 0 ? (
                <Col span={24} style={{ width: '100%' }}>
                  <p
                    style={{ margin: 0, fontWeight: 'bold' }}
                    className={classes.fontQuicksand}
                  >
                    Servicios Adicionales
                  </p>
                  {selectedAddons.map((addon, index) => (
                    <Row
                      gutter={16}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        margin: '0',
                      }}
                      key={addon.key}
                      className={classes.fontMuli}
                    >
                      <Col
                        style={{
                          display: 'flex',
                          margin: '0',
                          justifyContent: 'start',
                          alignItems: 'center',
                          width: '60%',
                        }}
                      >
                        <Checkbox
                          checked={addon.selected}
                          onChange={(e) =>
                            addon.isSpecial
                              ? handleAddonsSpecial(
                                e.target.checked,
                                addon,
                                index,
                              )
                              : handleAddons(e.target.checked, addon, index)
                          }
                        />
                        <small
                          style={{
                            textTransform: 'capitalize',
                            marginLeft: '1%',
                          }}
                        >
                          {addon.name}
                        </small>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          margin: '0',
                          justifyContent: 'end',
                          alignItems: 'center',
                          width: '40%',
                        }}
                      >
                        {addon.isSpecial && (
                          <div
                            style={{
                              width: '100%',

                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Col style={{ justifyContent: 'end' }}>
                              <InputNumber
                                disabled={!addon.selected}
                                defaultValue={1}
                                style={{
                                  marginRight: '10px',
                                  width: '50px',
                                  height: '30px',
                                  justifyContent: 'center',
                                }}
                                // value={!!addon.quantity ? addon.quantity : 0}
                                min={1}
                                onChange={(value) =>
                                  handleChangeQty(
                                    parseInt(value),
                                    addon,
                                    index,
                                  )
                                }
                              />
                            </Col>
                            <Col
                              style={{
                                justifyContent: 'end',
                              }}
                            >
                              <small>
                                <CurrencyFormat
                                  value={addon.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                                {addon.isSpecial && '/un'}
                              </small>
                            </Col>
                          </div>
                        )}

                        {!addon.isSpecial && (
                          <>
                            <Col
                              style={{
                                justifyContent: 'end',
                              }}
                            >
                              <small>
                                <CurrencyFormat
                                  value={addon.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              </small>
                            </Col>
                          </>
                        )}
                      </Col>
                    </Row>
                  ))}
                </Col>
              ) : null}

              <Row gutter={16} style={{ width: '100%' }}>
                <hr className="hr-style" />

                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Precio por Persona{' '}
                  <CurrencyFormat
                    value={singleExperience.valuePerPerson}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>

                {selectedAddons && selectedAddons.length > 0 ? (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginLeft: '2%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Adicionales{' '}
                    <CurrencyFormat
                      value={addonsPrice ? addonsPrice : 0}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                ) : null}

                {selectedAddons && selectedAddons.length > 0 ? (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      marginLeft: '2%',

                      width: '100%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Adicionales por persona{' '}
                    <CurrencyFormat
                      value={addonsPersonsPrice}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                ) : null}

                <hr className="hr-style" />
                {singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? null : (
                  <Col
                    style={{
                      display: 'flex',
                      margin: 'auto',
                      paddingTop: '2%',
                      justifyContent: 'space-between',
                      marginLeft: '2%',

                      width: '100%',
                    }}
                    className={classes.fontQuicksand}
                  >
                    Reserva{' '}
                    <CurrencyFormat
                      value={
                        !!reservationPrice
                          ? reservationPrice +
                          addonsPrice +
                          addonsPersonsPrice
                          : 0
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </Col>
                )}
              </Row>

              {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                hotDeal ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Tooltip title="Usted realizará el pago de su pre-reserva">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span style={{}}>{`Pago diferido`}</span>
                </p>
              ) : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span style={{}}>{`Pago diferido`}</span>
                </p>
              ) : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage !== 0 ? (
                <p
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignContent: 'center',
                  }}
                >
                  <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                    <InfoIcon style={{ fontSize: '20px' }} />
                  </Tooltip>
                  <span
                    style={{ marginRight: '5px', marginLeft: '5px' }}
                  >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                  <CurrencyFormat
                    value={
                      ((!!reservationPrice
                        ? reservationPrice + addonsPrice + addonsPersonsPrice
                        : 0) *
                        singleExperience.partialPercentage) /
                      100
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </p>
              ) : null}
            </Row>

            <Space
              style={{
                width: '100%',
                marginTop: '2%',
                justifyContent: 'center',
              }}
            >
              <Button
                disabled={isExperiencesEnded}
                variant="contained"
                onClick={validateForm}
                className="btn"
              >
                Continuar
              </Button>
            </Space>
          </div>
        ),
      },
  ]

  return (
    <Layout>
      <Space>
        <Tabs
          defaultActiveKey="activeKey"
          items={items}
          onChange={handleChange}
          onTabClick={tabClick}
        ></Tabs>
      </Space>
    </Layout>
  )
}

export default ReservationDetailsHotel
